









































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { TagContentsParam } from "@/params/TagContentsParam";
import DialogCloseNavigation from "@/components/navigations/DialogCloseNavigation.vue";
import BasicVideoPlayer from "@/components/media/BasicVideoPlayer.vue";
import TagMovieContents from "@/components/vr-tags/contents/TagMovieContents.vue";

@Component({
  components: {
    TagMovieContents,
    BasicVideoPlayer,
    DialogCloseNavigation
  }
})
export default class VrTagMovieDialog extends Vue {
  public videoPlayer: BasicVideoPlayer;

  @Prop() isShown: boolean;
  @Prop() contents: TagContentsParam;
  @Prop({ default: '#191919' }) cardColor: string;
  @Prop({ default: false }) light: boolean;

  get parentDom (): HTMLDivElement {
    const $parent: HTMLDivElement = <HTMLDivElement> this.$parent.$el;
    return $parent;
  }

  get isSmp (): boolean {
    return this.$store.state.isSmp;
  }

  get isShownDialog (): boolean {
    return this.isShown;
  }
  set isShownDialog (value: boolean) {
    if (!value) {
      this.onCloseDialog();
    }
  }

  mounted (): void {
    this.$nextTick(() => {
      this.videoPlayer = <BasicVideoPlayer> this.$refs.videoPlayer;
    });
  }

  /**
   * ダイアログを閉じる処理時のイベントトリガー
   */
  @Emit('close')
  onCloseDialog (): void {
    // ビデオを止める
    this.videoPlayer.pauseVideo();
    // BGMを再生
    this.$store.commit('playBgm');
    // 非表示アニメーション後（0.3秒後）にリセット処理を加える
    setTimeout(() => {
      this.videoPlayer.reset();
    }, 300);
  }
}
